import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_item_review_rating_config_hdr_RowClass} from '../../../dbschema';

export class ReviewRatingConfigContainerModel extends BaseContainerModel {
  bl_fi_item_review_rating_config_hdr: bl_fi_item_review_rating_config_hdr_RowClass = new bl_fi_item_review_rating_config_hdr_RowClass();
}
